import React, { useMemo } from 'react';
import { Grid, Typography } from '@mui/material';
import { useColorScheme, useTheme } from '@mui/material/styles';
import {
    Elements,
    PaymentElement,
    ElementsConsumer,
} from '@stripe/react-stripe-js';
import {
    createStripeFormAppearance,
    stripeCustomFont,
    stripeFormOptions,
    stripePromise,
} from '../../../utils/stripe';
import { Stripe, StripeElements } from '@stripe/stripe-js';
import { StripePendingSubscription } from '../../../gql/subscriptions';
import { getConcretePalette } from '../../../utils/theme.utils';

interface StripePaymentFormProps {
    onElementsReady: (
        stripe: Stripe | null,
        elements: StripeElements | null
    ) => void;
    stripeSubscriptionData: StripePendingSubscription;
}

export const StripePaymentForm = ({
    onElementsReady,
    stripeSubscriptionData,
}: StripePaymentFormProps) => {
    const theme = useTheme();
    const { mode, systemMode } = useColorScheme();
    const palette = getConcretePalette(theme, mode, systemMode);
    const stripeFormAppearance = useMemo(
        () => createStripeFormAppearance(theme, palette),
        [theme, palette]
    );

    return (
        <Grid container spacing={1}>
            <Grid size={12}>
                <Elements
                    stripe={stripePromise}
                    options={{
                        clientSecret:
                            stripeSubscriptionData.createStripeSubscription
                                .clientSecret,
                        fonts: stripeCustomFont,
                        appearance: stripeFormAppearance,
                    }}
                >
                    <ElementsConsumer>
                        {({ stripe, elements }) => (
                            <PaymentElement
                                options={stripeFormOptions}
                                onReady={() =>
                                    onElementsReady(stripe, elements)
                                }
                            />
                        )}
                    </ElementsConsumer>
                </Elements>
            </Grid>
            <Grid size={12}>
                <Typography
                    variant="body2"
                    sx={{
                        color: 'text.secondary',
                    }}
                >
                    Payment services provided by Stripe
                </Typography>
            </Grid>
        </Grid>
    );
};
